import * as EditScreenToolbar from "./EditScreenToolbar";
import EditScreenHeaderTemplate from "../../compiled-templates/EditScreenHeaderTemplate";

/**
 *
 * @param {EditPresenter} presenter
 */
export function render(presenter) {
    let header = $(EditScreenHeaderTemplate());
    let toolbar = header.find(".editScreen#toolbar");
    EditScreenToolbar.initiEditScreenToolbar(toolbar, presenter);
    toolbar.find("span").css("font-size", "20px");
    presenter.header = header;
    presenter.editScreenToolbar = toolbar;
    return header;
}